import api  from './api';

export const login = (email, password, remember) =>
    api.post('/login', { email, password, remember });

export const logout = () =>
    api.post('/logout');

export const checkAuth = () =>
    api.get('/auth/status');

export const requestPasswordChange = (email) =>
    api.post('/request-password-change', { email });